import React from "react";
import Link from "next/link";
import { BiPhone, BiEnvelope, BiLogoLinkedin } from "react-icons/bi";
import { useTranslations } from '../../locales/useTranslations';

const ItConsultingInfoAndCTA = () => {
  const { t } = useTranslations();

  return (
    <>
      <div className="service-details pb-70">
        <div className="container">
          <div className="service-details-content">

            <div className="pt-35">
              <h2>{t('itConsulting_info_title')}</h2>
              <br />
              <h4>{t('itConsulting_info_description')}</h4>
              <ul>
                <li>{t('itConsulting_info_benefits_1')}</li>
                <li>{t('itConsulting_info_benefits_2')}</li>
                <li>{t('itConsulting_info_benefits_3')}</li>
                <li>{t('itConsulting_info_benefits_4')}</li>
                <li>{t('itConsulting_info_benefits_5')}</li>
                <li>{t('itConsulting_info_benefits_6')}</li>
                <li>{t('itConsulting_info_benefits_7')}</li>
                <li>{t('itConsulting_info_benefits_8')}</li>
              </ul>
            </div>

            <div className="pt-35">
              <h3>{t('itConsulting_cta_title')}</h3>
              <p>
                {t('itConsulting_cta_description')}
              </p>
            </div>

            <div className="service-details pt-35">
              <div className="service-details-info ">
                <div className="large-info-box">
                  <h4>{t('itConsulting_cta_title')}</h4>
                  <span>{t('itConsulting_cta_description')}</span>
                </div>

                <div className="single-info-box">
                  <h4>{t('itConsulting_cta_contact_title')}</h4>
                  <ul className="social">
                    <li>
                      <a href="tel://+4943170577024" target="_blank">
                        <BiPhone />
                      </a>
                    </li>
                    <li>
                      <a href="mailto:info@simplify-data.de" target="_blank">
                        <BiEnvelope />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com/company/simplify-data-gmbh" target="_blank">
                        <BiLogoLinkedin />
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="single-info-box">
                  <Link href="/kontakt/" className="default-btn">
                    {t('itConsulting_cta_contact_button')}
                  </Link>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default ItConsultingInfoAndCTA;
